import { isRouteErrorResponse, Link, Outlet, ScrollRestoration, useNavigation, useRouteError } from "react-router";
import Medallion from "@/components/common/Medallion";

export default function App() {
	const navigation = useNavigation();

	return (
		<>
			{/* Route progress: starts after 120ms so cached navigations never show
			    it, eases towards 85% and unmounts when done (no shrinking back). */}
			{navigation.state === "loading" ? (
				<div
					aria-hidden
					className="fixed inset-x-0 top-0 z-[100] h-0.5 origin-left animate-progress bg-gold-400 print:hidden"
				/>
			) : null}
			<Outlet />
			<ScrollRestoration />
		</>
	);
}

export function ErrorPage() {
	const error = useRouteError();
	const notFound = isRouteErrorResponse(error) && error.status === 404;

	return (
		<main className="flex min-h-svh flex-col items-center justify-center gap-4 bg-paper-50 p-6 text-center">
			<Medallion className="size-14 text-base">{notFound ? "404" : "!"}</Medallion>
			<h1 className="text-2xl font-semibold tracking-tight text-ink">
				{notFound ? "Stranica nije pronađena" : "Nešto je pošlo po zlu"}
			</h1>
			<p className="max-w-sm text-ink-muted">
				{notFound
					? "Stranica koju tražite ne postoji."
					: "Molimo osvježite stranicu ili pokušajte ponovo kasnije."}
			</p>
			<Link
				to="/"
				className="pressable inline-flex h-11 items-center rounded-full bg-emerald-900 px-6 text-sm font-semibold text-paper-50 hover:bg-emerald-800"
			>
				Početna
			</Link>
		</main>
	);
}
